import React from 'react'
import { 
    LoadMore, Cell, CellBody, CellFooter, CellHeader, Badge
} from 'react-weui'
import { getHumanTime, replaceNewHost } from '../../utils'
import { toChatPage } from '../../services'
import { WKVisible } from '../../components/wk'
import {NoneItem} from '../../components/details'


class NewSystem extends React.Component {
    handleClickItem (item) {
        toChatPage(item.sender_id)
        // location.assign(`/message/chat/${item.sender_id}`)
    }
    renderMyItem (item) {
        //getHumanTime里length = 13的判断不敢随意改动 只能这里魔改了
        const timeArray = String(item.create_timestamp).split('.')
        const time = timeArray[1] && timeArray[1].length === 2
            ? timeArray[0]
            : item.create_timestamp
        return (
            <Cell onClick={() => this.handleClickItem(item)} key={item.create_timestamp} href="javascript:;" access>
                <CellHeader>
                    <div className="avatar">
                        <img src={this.getHeadImg(item.avatar)} />
                    </div>
                </CellHeader>
                <CellBody className='text-ellipsis'>
                    <p className='big-font nickname text-ellipsis'>{item.nickname}</p>
                    <p className='text-minor text-ellipsis msg-text'>{item.content}</p>
                </CellBody>

                <CellFooter>
                    <p className='my-time'>{getHumanTime(time)}</p>
                    <WKVisible create={item.unread > 0}>
                        <Badge preset='footer'>{item.unread}</Badge>
                    </WKVisible>
                </CellFooter>
            </Cell>
        )
    }

    getHeadImg (url, size = 32) {
        const avatar_prefix = 'https://static-1253442168.image.myqcloud.com/'
        if (url.includes('.sinaimg.cn') || url.includes('.qlogo.cn') || url.includes('img.weike.fm') || url.includes('img.lycheer.net')){
            url = replaceNewHost(url)
            return url
        }
        if (!url){
            return 'http://wx.qlogo.cn/mmopen/NPtydQsdvKwgNS5bv0q5MUcayv3Fn4g0j0EjcMlickQWOZuUmxURngohNNDeAEoAfrlYoKfXXYiaaQTRZdE3vByj6crLNJMYfib/0'
        }
        if (/^http:\/\/wx/.test(url)) {
            url = url.slice(0) + str(size)
        } else {
            if (/^http:\/\/wx/.test(url)){
                url = avatar_prefix + url
            } else if ( /^\/media/.test(url)){
                url = avatar_prefix + url.slice(6)
            }else{
                url = avatar_prefix + encodeURI(url)
            }
            if (size === 32){
                url += '-avatarnew'
            }
            if (size === 64){
                url += '-avatar64'
            }
        }
        url = replaceNewHost(url)
        return url
    }
    renderMyMsgs (msgs) {
        const unreadMsgs = []
        const normalMsgs = []
        msgs.forEach(item => {
            if (item.unread > 0) {
                unreadMsgs.push(item)
            } else {
                normalMsgs.push(item)
            }
        })
        return unreadMsgs.concat(normalMsgs).map(item => this.renderMyItem(item))
    }
    render() {
        if (this.props.tabId != 1) return null
        if (!this.props.systemMsgs) return <LoadMore loading></LoadMore>
        if(this.props.systemMsgs.length === 0) return (
            <div style={{width: '100%', height: '100vh', position: 'relative'}}>
                <NoneItem
                    img="https://static-1253442168.image.myqcloud.com/picture/5915685_2b0452b9e0f084e290705183b06dd05d.jpg"
                    text="此处暂无消息哦"
                />
            </div>
        )
        return (
            <div className="my">
                {
                    this.renderMyMsgs(this.props.systemMsgs)
                }
                <div className="load-more" style={{width: '100%', height: '40px', display: 'flex', justifyContent: 'center', alignItems: 'center', color: '#999'}}>{this.props.hasMore ? '加载中..' : '没有更多了'}</div>
            </div>
        )
    }
}

export default NewSystem


// WEBPACK FOOTER //
// ./src/components/message/NewSystem.js